import { bindRequestLogic } from './utils'
import CIXIReferentType from '../actionTypes/cixiReferent'
import { cixiReferentAPI } from '../api'

const getCixiReferents = bindRequestLogic({
  clientFunc: cixiReferentAPI.getCixiReferents,
  type: CIXIReferentType.GET_CIXI_REFERENTS_REQUEST,
  successType: CIXIReferentType.GET_CIXI_REFERENTS_SUCCESS,
  failType: CIXIReferentType.GET_CIXI_REFERENTS_FAILED,
  isQueryParam: true
})

const addCixiReferent = bindRequestLogic({
  clientFunc: cixiReferentAPI.addCixiReferent,
  type: CIXIReferentType.ADD_CIXI_REFERENT_REQUEST,
  successType: CIXIReferentType.ADD_CIXI_REFERENT_SUCCESS,
  failType: CIXIReferentType.ADD_CIXI_REFERENT_FAILED
})

const getCixiReferentDetail = bindRequestLogic({
  clientFunc: cixiReferentAPI.getCixiReferentDetail,
  type: CIXIReferentType.GET_CIXI_REFERENT_DETAIL_REQUEST,
  successType: CIXIReferentType.GET_CIXI_REFERENT_DETAIL_SUCCESS,
  failType: CIXIReferentType.GET_CIXI_REFERENT_DETAIL_FAILED,
  modelName: 'companyCIXIReferent'
})

const deleteCixiReferent = bindRequestLogic({
  clientFunc: cixiReferentAPI.deleteCixiReferent,
  type: CIXIReferentType.DELETE_CIXI_REFERENT_REQUEST,
  successType: CIXIReferentType.DELETE_CIXI_REFERENT_SUCCESS,
  failType: CIXIReferentType.DELETE_CIXI_REFERENT_FAILED
})

const updateCixiReferent = bindRequestLogic({
  clientFunc: cixiReferentAPI.updateCixiReferent,
  type: CIXIReferentType.UPDATE_CIXI_REFERENT_REQUEST,
  successType: CIXIReferentType.UPDATE_CIXI_REFERENT_SUCCESS,
  failType: CIXIReferentType.UPDATE_CIXI_REFERENT_FAILED
})

const getSystemCixiReferents = bindRequestLogic({
  clientFunc: cixiReferentAPI.getSystemCixiReferents,
  type: CIXIReferentType.GET_SYSTEM_COMPANY_CIXI_REFERENTS_REQUEST,
  successType: CIXIReferentType.GET_SYSTEM_COMPANY_CIXI_REFERENTS_SUCCESS,
  failType: CIXIReferentType.GET_SYSTEM_COMPANY_CIXI_REFERENTS_FAILED,
  isQueryParam: true
})

export default [
  getCixiReferents,
  addCixiReferent,
  getCixiReferentDetail,
  deleteCixiReferent,
  updateCixiReferent,
  getSystemCixiReferents
]
